import {
    createReportAttachmentDownloadUrl,
    parseReportAttachments
} from '@/plugin/reportAttachment'

export const createColumns = ({
    toDetail,
    editDetail,
    deleteAction,
    token
}) => [{
    title: '产品编码',
    key: 'skuCode',
    width: 200,
    render: (h, p) => {
        return h('div', [
            h('a', {
                on: {
                    click: () => {
                        toDetail(p)
                    },
                }
            }, p.row.skuCode)
        ])
    }
}, {
    title: '产品名称',
    key: 'skuName',
}, {
    title: '批次号',
    key: 'pici',
    width: 200,
},
{
    title: '附件名称',
    key: 'fujianAddr',
    render: (h, p) => {
        const attachments = parseReportAttachments(p.row.fujianAddr)
        if (!attachments.length) return h('span', '')
        return h('div', attachments.map(attachment => {
            return h('a', {
                key: attachment.storedName,
                style: {
                    display: 'block',
                    lineHeight: '24px'
                },
                on: {
                    click: () => {
                        window.open(createReportAttachmentDownloadUrl(p.row.id,attachment.storedName,token))
                    }
                }
            }, attachment.originalName)
        }))
    }
},
//{
//     title: '操作',
//     render: (h, p) => {
//         return h('div', [
//             h('a', {
//                 on: {
//                     click: () => {
//                         editDetail(p)
//                     }
//                 }
//             }, '编辑'),
//             h('a', {
//                 style: {
//                     marginLeft: '10px',
//                     color: 'red'
//                 },
//                 on: {
//                     click: () => {
//                         deleteAction(p)
//                     }
//                 }
//             }, '删除')
//         ])
//     }
// }
]
